(function () {
  var section = document.querySelector("[data-subscription]");
  if (!section) return;

  document.body.classList.add("subscription-page");

  var TIERS = [];
  try {
    TIERS = JSON.parse(section.getAttribute("data-tiers") || "[]");
  } catch (e) {
    TIERS = [
      { qty: 3, discount: 15 },
      { qty: 4, discount: 20 },
      { qty: 5, discount: 25 },
    ];
  }

  var SELLING_PLANS = [];
  try {
    SELLING_PLANS = JSON.parse(section.getAttribute("data-selling-plans") || "[]");
  } catch (e) {
    SELLING_PLANS = [];
  }
  TIERS.sort(function (a, b) {
    return a.qty - b.qty;
  });

  var MAX_QTY = parseInt(section.getAttribute("data-max-qty"), 10) || 5;
  var MIN_QTY = parseInt(section.getAttribute("data-min-qty"), 10) || 3;
  var VISIBLE_CATEGORIES = parseInt(section.getAttribute("data-visible-categories"), 10) || 4;
  var MONEY_FORMAT = section.getAttribute("data-money-format") || "${{amount}}";
  var CART_URL = section.getAttribute("data-cart-url") || "/cart/add";

  var tabs = section.querySelectorAll("[data-subscription-tab]");
  var firstTab = tabs.length ? tabs[0].getAttribute("data-subscription-tab") : "";

  var state = {
    tab: section.getAttribute("data-active-tab") || firstTab || "",
    selected: [],
    expanded: false,
    loading: false,
    rhythm: "1",
  };

  var PRODUCTS = {};

  section.querySelectorAll("[data-subscription-product]").forEach(function (card) {
    var id = card.getAttribute("data-subscription-product");
    if (!id) return;

    if (!PRODUCTS[id]) {
      var planIdsStr = card.getAttribute("data-selling-plan-ids") || '';
      var planIds = planIdsStr ? planIdsStr.split(',').map(function(s) { return parseInt(s.trim(), 10); }).filter(Boolean) : [];
      PRODUCTS[id] = {
        id: id,
        variantId: card.getAttribute("data-variant-id"),
        name: card.getAttribute("data-product-name") || "",
        price: parseInt(card.getAttribute("data-product-price"), 10) || 0,
        available: !card.hasAttribute("data-unavailable"),
        sellingPlanIds: planIds,
        cards: [],
      };
    }

    PRODUCTS[id].cards.push(card);
    if (!PRODUCTS[id].available && !card.hasAttribute("data-unavailable")) {
      PRODUCTS[id].available = true;
    }
  });

  var catalogEl = section.querySelector("[data-subscription-catalog]");
  var tierPanels = section.querySelectorAll("[data-subscription-tier]");
  var progressFill = section.querySelector("[data-subscription-progress-fill]");
  var progressThumb = section.querySelector("[data-subscription-progress-thumb]");
  var progressCount = section.querySelector("[data-subscription-progress-count]");
  var progressUnlock = section.querySelector("[data-subscription-progress-unlock]");
  var moreBtn = section.querySelector("[data-subscription-more]");
  var moreWrap = section.querySelector("[data-subscription-more-wrap]");
  var rhythmStepEl = section.querySelector("[data-subscription-rhythm-step]");
  var rhythmWeeksEl = section.querySelector("[data-subscription-rhythm-weeks]");
  var selectedList = section.querySelector("[data-subscription-selected]");
  var subtotalEl = section.querySelector("[data-subscription-subtotal]");
  var discountEl = section.querySelector("[data-subscription-discount]");
  var totalEl = section.querySelector("[data-subscription-total]");
  var shippingEl = section.querySelector("[data-subscription-shipping]");
  var ctaBtn = section.querySelector("[data-subscription-cta]");
  var shippingCents = null;
  var shippingLoaded = false;

  function formatMoney(cents) {
    var amount = (Math.max(cents, 0) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Math.max(cents, 0) / 100));
    var amountWithComma = amount.replace(".", ",");
    var formatted = "";

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      formatted = Shopify.formatMoney(cents, MONEY_FORMAT);
    } else {
      formatted = MONEY_FORMAT
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    var tmp = document.createElement("div");
    tmp.innerHTML = formatted;
    return (tmp.textContent || tmp.innerText || "").trim() || "$" + amount;
  }

  function discountForCount(count) {
    var discount = 0;
    TIERS.forEach(function (tier) {
      if (count >= tier.qty) discount = tier.discount;
    });
    return discount;
  }

  function isSelected(id) {
    return state.selected.indexOf(id) !== -1;
  }

  function escapeHtml(text) {
    var el = document.createElement("span");
    el.textContent = text || "";
    return el.innerHTML;
  }

  function updateCards() {
    Object.keys(PRODUCTS).forEach(function (id) {
      var product = PRODUCTS[id];
      var active = isSelected(id);

      product.cards.forEach(function (card) {
        card.classList.toggle("is-added", active);

        if (card.hasAttribute("data-unavailable")) return;

        card.setAttribute("aria-pressed", active ? "true" : "false");
        card.setAttribute(
          "aria-label",
          (active ? "Remove " : "Add ") +
            (product.name || "") +
            (active ? " from subscription" : " to subscription")
        );

        var addEl = card.querySelector("[data-subscription-add]");
        if (addEl) {
          addEl.classList.toggle("is-added", active);
          var textEl = addEl.querySelector("[data-subscription-add-text]");
          if (textEl) textEl.textContent = active ? "In cart" : "Add to cart";
          var icon = addEl.querySelector("[data-subscription-add-icon]");
          if (icon) {
            var nextSrc = active
              ? icon.getAttribute("data-icon-added")
              : icon.getAttribute("data-icon-default");
            if (nextSrc) icon.src = nextSrc;
          }
        }
      });
    });
  }

  function getActiveCategories() {
    return Array.prototype.slice.call(
      section.querySelectorAll('[data-subscription-category-tab="' + state.tab + '"]')
    );
  }

  function updateCategories() {
    var allCategories = section.querySelectorAll("[data-subscription-category]");
    var activeCategories = getActiveCategories();

    allCategories.forEach(function (category) {
      var tabId = category.getAttribute("data-subscription-category-tab");
      var isActiveTab = tabId === state.tab;
      category.classList.toggle("is-tab-hidden", !isActiveTab);
    });

    activeCategories.forEach(function (category, index) {
      var collapsed = !state.expanded && index >= VISIBLE_CATEGORIES;
      category.classList.toggle("is-hidden", collapsed);
    });

    if (moreWrap) {
      moreWrap.hidden = activeCategories.length <= VISIBLE_CATEGORIES;
    }
    if (moreBtn) {
      moreBtn.setAttribute("aria-expanded", state.expanded ? "true" : "false");
      var label = moreBtn.querySelector("[data-subscription-more-label]");
      if (label) label.textContent = state.expanded ? "Show less" : "Show more";
      moreBtn.classList.toggle("is-open", state.expanded);
    }
    if (rhythmStepEl) {
      rhythmStepEl.textContent = String(activeCategories.length + 1);
    }
  }

  function updateTabs() {
    tabs.forEach(function (btn) {
      var active = btn.getAttribute("data-subscription-tab") === state.tab;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
    section.setAttribute("data-active-tab", state.tab);
  }

  function updateProgress() {
    var count = state.selected.length;
    var pct = Math.min((count / MAX_QTY) * 100, 100);
    var discount = discountForCount(count);

    if (progressCount) {
      progressCount.textContent = count + " item" + (count !== 1 ? "s" : "") + " selected";
    }
    if (progressUnlock) {
      if (discount > 0) {
        progressUnlock.textContent = discount + "% off unlocked";
      } else {
        progressUnlock.textContent = "Add " + MIN_QTY + "+ items to unlock discount";
      }
      progressUnlock.hidden = false;
      progressUnlock.classList.toggle("is-muted", discount === 0);
    }
    if (progressFill) progressFill.style.width = pct + "%";
    if (progressThumb) {
      var ratio = Math.min(count / MAX_QTY, 1);
      progressThumb.style.left = "calc((100% - 30px) * " + ratio + ")";
    }

    tierPanels.forEach(function (panel) {
      var qty = Number(panel.getAttribute("data-subscription-tier"));
      panel.classList.toggle("is-active", count >= qty);
    });
  }

  function updateSidebar() {
    var items = state.selected
      .map(function (id) {
        return PRODUCTS[id];
      })
      .filter(Boolean);

    var subtotal = items.reduce(function (sum, item) {
      return sum + item.price;
    }, 0);
    var discountPct = discountForCount(items.length);
    var discountValue = Math.round((subtotal * discountPct) / 100);
    var productTotal = Math.max(subtotal - discountValue, 0);
    var shippingCost = shippingCents === null ? 0 : shippingCents;
    var total = productTotal + shippingCost;

    if (selectedList) {
      if (!items.length) {
        selectedList.innerHTML =
          '<p class="subscription__empty">No products selected yet</p>';
      } else {
        selectedList.innerHTML = items
          .map(function (item) {
            return (
              '<div class="subscription__selected-row">' +
              '<p class="subscription__selected-name">' +
              escapeHtml(item.name) +
              "</p>" +
              '<span class="subscription__selected-price">' +
              formatMoney(item.price) +
              "</span>" +
              "</div>"
            );
          })
          .join("");
      }
    }

    if (shippingEl) {
      if (!shippingLoaded) {
        shippingEl.textContent = "Calculating…";
      } else if (shippingCents === null) {
        shippingEl.textContent = "At checkout";
      } else {
        shippingEl.textContent = formatMoney(shippingCents);
      }
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (discountEl) {
      discountEl.textContent =
        discountValue > 0 ? "−" + formatMoney(discountValue) : formatMoney(0);
    }
    if (totalEl) {
      totalEl.textContent =
        shippingLoaded && shippingCents === null
          ? formatMoney(productTotal)
          : formatMoney(total);
    }
    if (ctaBtn) {
      ctaBtn.disabled = state.loading || items.length < MIN_QTY;
    }
  }

  function loadShippingEstimate() {
    if (!shippingEl) {
      shippingLoaded = true;
      return Promise.resolve();
    }

    var fetchRates =
      typeof window.getShopifyShippingCents === "function"
        ? window.getShopifyShippingCents({
            country: section.getAttribute("data-shipping-country") || "AU",
            province: section.getAttribute("data-shipping-province") || "",
            zip: section.getAttribute("data-shipping-zip") || "",
          })
        : Promise.resolve(null);

    return fetchRates
      .then(function (cents) {
        shippingCents = typeof cents === "number" ? cents : null;
      })
      .catch(function () {
        shippingCents = null;
      })
      .finally(function () {
        shippingLoaded = true;
        updateSidebar();
      });
  }

  function updateRhythmUI() {
    var activeBtn = null;
    section.querySelectorAll("[data-subscription-rhythm]").forEach(function (btn) {
      var active = btn.getAttribute("data-subscription-rhythm") === state.rhythm;
      btn.classList.toggle("is-active", active);
      if (active) activeBtn = btn;
    });

    if (rhythmWeeksEl && activeBtn) {
      rhythmWeeksEl.textContent = activeBtn.getAttribute("data-rhythm-period") || "";
    }
  }

  function render() {
    updateTabs();
    updateCards();
    updateCategories();
    updateProgress();
    updateSidebar();
    updateRhythmUI();
  }

  function setTab(tabId) {
    if (!tabId || tabId === state.tab) return;
    state.tab = tabId;
    state.expanded = false;
    render();
  }

  function setRhythm(id) {
    if (!id || id === state.rhythm) return;
    state.rhythm = id;
    updateRhythmUI();
  }

  function toggleProduct(id) {
    var product = PRODUCTS[id];
    if (!product || !product.available) return;

    var index = state.selected.indexOf(id);
    if (index !== -1) {
      state.selected.splice(index, 1);
    } else {
      state.selected.push(id);
    }
    render();
  }

  function getActiveSellingPlan() {
    var activeRhythmBtn = section.querySelector('[data-subscription-rhythm="' + state.rhythm + '"]');
    if (!activeRhythmBtn) return '';

    var manualId = (activeRhythmBtn.getAttribute('data-selling-plan') || '').trim();
    if (manualId) return manualId;

    if (!SELLING_PLANS.length) return '';

    var btnLabel = (activeRhythmBtn.textContent || '').trim().toLowerCase();
    var btnPeriod = (activeRhythmBtn.getAttribute('data-rhythm-period') || '').trim().toLowerCase();
    var btnText = (btnLabel + ' ' + btnPeriod).replace(/\s+/g, ' ').trim();

    function planName(plan) {
      return String(plan.name || '').toLowerCase();
    }

    function findPlan(testBtn, testPlan) {
      if (!testBtn(btnText)) return null;
      for (var i = 0; i < SELLING_PLANS.length; i++) {
        if (testPlan(planName(SELLING_PLANS[i]))) return SELLING_PLANS[i];
      }
      return null;
    }

    // Most specific first — "2 months" / "6 months" before plain "month"
    var matched =
      findPlan(
        function (t) { return /\b2\s*months?\b|bi[\s-]?month|every\s*2\s*months?/.test(t); },
        function (p) { return /\b2\s*months?\b|bi[\s-]?month|every\s*2\s*months?/.test(p); }
      ) ||
      findPlan(
        function (t) { return /\b6\s*months?\b|half[\s-]?year|bi[\s-]?annua|semi[\s-]?annua/.test(t); },
        function (p) { return /\b6\s*months?\b|half[\s-]?year|bi[\s-]?annua|semi[\s-]?annua/.test(p); }
      ) ||
      findPlan(
        function (t) { return /\byears?\b|\byearly\b/.test(t) && !/\b\d+\s*months?\b|half/.test(t); },
        function (p) { return /\byears?\b|\byearly\b/.test(p) && !/\b\d+\s*months?\b|half/.test(p); }
      ) ||
      findPlan(
        function (t) { return /\bmonths?\b|\bmonthly\b/.test(t) && !/\b\d+\s*months?\b|bi[\s-]?month/.test(t); },
        function (p) { return /\bmonths?\b|\bmonthly\b/.test(p) && !/\b\d+\s*months?\b|bi[\s-]?month/.test(p); }
      ) ||
      findPlan(
        function (t) { return /\bweeks?\b/.test(t); },
        function (p) { return /\bweeks?\b/.test(p) && !/\bmonths?\b/.test(p); }
      );

    if (matched) return String(matched.id);

    return String(SELLING_PLANS[0].id || '');
  }

  function getBundledSectionsPayload() {
    var ids = [];
    var drawer = document.querySelector('[data-cart-drawer-root]');
    if (drawer && drawer.dataset.sectionId) ids.push(drawer.dataset.sectionId);
    var cartRoot = document.querySelector('[data-main-cart-root]');
    if (cartRoot && cartRoot.dataset.sectionId) ids.push(cartRoot.dataset.sectionId);
    if (!ids.length) return {};
    var cartPath = (window.__glowRoutes && window.__glowRoutes.cartUrl) || '/cart';
    if (cartPath.charAt(0) !== '/') cartPath = '/' + cartPath;
    return { sections: ids.join(','), sections_url: cartPath };
  }

  function addSubscriptionToCart() {
    if (state.loading || state.selected.length < MIN_QTY) return;

    var sellingPlan = getActiveSellingPlan();
    var sellingPlanNum = sellingPlan ? parseInt(sellingPlan, 10) : 0;

    var items = state.selected
      .map(function (id) {
        var product = PRODUCTS[id];
        if (!product || !product.variantId) return null;
        var item = {
          id: parseInt(product.variantId, 10),
          quantity: 1,
        };
        if (sellingPlanNum && product.sellingPlanIds && product.sellingPlanIds.indexOf(sellingPlanNum) !== -1) {
          item.selling_plan = sellingPlanNum;
        }
        return item;
      })
      .filter(Boolean);

    if (!items.length) return;

    state.loading = true;
    if (ctaBtn) ctaBtn.disabled = true;

    var payload = Object.assign({ items: items }, getBundledSectionsPayload());

    fetch(CART_URL + (CART_URL.indexOf(".js") !== -1 ? "" : ".js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart add failed");
        return res.json();
      })
      .then(function (data) {
        if (data && data.sections && window.cartUi && window.cartUi.applyBundledSections) {
          window.cartUi.applyBundledSections(data.sections);
        }
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: { openDrawer: true } })
        );
        state.selected = [];
        render();
      })
      .catch(function () {})

      .finally(function () {
        state.loading = false;
        render();
      });
  }

  tabs.forEach(function (btn) {
    btn.addEventListener("click", function () {
      setTab(btn.getAttribute("data-subscription-tab"));
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      state.expanded = !state.expanded;
      render();
    });
  }

  section.addEventListener("click", function (event) {
    var rhythmBtn = event.target.closest("[data-subscription-rhythm]");
    if (rhythmBtn && section.contains(rhythmBtn)) {
      event.preventDefault();
      setRhythm(rhythmBtn.getAttribute("data-subscription-rhythm"));
      return;
    }

    var toggle = event.target.closest("[data-subscription-toggle]");
    if (!toggle || !section.contains(toggle)) return;
    event.preventDefault();
    if (toggle.hasAttribute("data-unavailable") || toggle.classList.contains("is-unavailable")) return;
    toggleProduct(toggle.getAttribute("data-subscription-toggle"));
  });

  section.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var toggle = event.target.closest("[data-subscription-toggle]");
    if (!toggle || !section.contains(toggle)) return;
    event.preventDefault();
    if (toggle.hasAttribute("data-unavailable") || toggle.classList.contains("is-unavailable")) return;
    toggleProduct(toggle.getAttribute("data-subscription-toggle"));
  });

  if (ctaBtn) {
    ctaBtn.addEventListener("click", function (event) {
      event.preventDefault();
      addSubscriptionToCart();
    });
  }

  render();
  loadShippingEstimate();
})();
